import { render, staticRenderFns } from "./SerialNumber.vue?vue&type=template&id=3998f0a1&scoped=true&"
import script from "./SerialNumber.vue?vue&type=script&lang=js&"
export * from "./SerialNumber.vue?vue&type=script&lang=js&"
import style0 from "./SerialNumber.vue?vue&type=style&index=0&id=3998f0a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3998f0a1",
  null
  
)

export default component.exports